import * as _ from 'lodash';

export { safeHref } from '../../../utils/url';

export function getFieldValue(source, mapping, fieldName, defaultValue = null) {
  const propertyPath = mapping?.[fieldName];
  if (!propertyPath) {
    return defaultValue;
  }

  return _.get(source, propertyPath, defaultValue);
}
